import { Laptop, Users } from "lucide-react";
import React from "react";
const SessionTypeIcon = ({ type }) => {
  if (type.toLowerCase() === "zoom") {
    return <Laptop className="h-5 w-5 text-purple-500" />;
  }
  return <Users className="h-5 w-5 text-blue-500" />;
};
export default SessionTypeIcon;
